export function getCurrentEnv(): 'prod' | 'dev' {
  return (document.querySelector('meta[name="current-env"]') as HTMLMetaElement)
    .content as 'prod' | 'dev'
}
